// TODO: Move outside the project code
const PERSPECTIVE_API_KEY = 'AIzaSyCs1evNe-1ezAfIDnncyDjyEOqvyzXH0so'

export const analyzeText = async (text: string, reply?: string) => {
  try {
    console.log('CSky: Analyzing text:', text) // Debug log

    // Request body for Perspective API w/ proper typing to avoid compile issues
    // Added ability to include context entry from original post if specified
    let reqBody: {
      comment: {text: string}
      // Added context entry
      context: {entries: {text: string}[]}
      requestedAttributes: {TOXICITY: {}}
      languages: string[]
    } = {
      comment: {text},
      context: {entries: []},
      requestedAttributes: {
        TOXICITY: {},
      },
      languages: ['en'], // Specify language if needed
    }
    // Add replyTo to context if available
    if (reply) reqBody.context.entries = [{text: reply}]

    const response = await fetch(
      `https://commentanalyzer.googleapis.com/v1alpha1/comments:analyze?key=${PERSPECTIVE_API_KEY}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reqBody),
      },
    )

    console.log('CSky: Response status:', response.status) // Debug log

    if (!response.ok) {
      const errorData = await response.json()
      console.error('API Error:', errorData) // Debug log

      throw new Error(errorData.error?.message || 'API request failed')
    }

    const data = await response.json()
    console.log('CSky: API Response:', data) // Debug log

    return data.attributeScores.TOXICITY.summaryScore.value
  } catch (error) {
    console.error('Full error details:', error) // Debug log
    throw error
  }
}
